/* Shared size parsing and compact choices; all purchasing variants remain available. */
(() => {
 if (window.NolvyaSizes) return;
 const parse = value => {
  const text=String(value||'').replace(/,/g,'.');
  const diameter=text.match(/(?:Ø|diam[eè]tre)\s*(\d+(?:\.\d+)?)\s*(cm|m)?/i);
  if(diameter){const n=Number(diameter[1])*(diameter[2]?.toLowerCase()==='m'?100:1);return n>=20&&n<=1200?{width:n,length:n,round:true,label:`Ø ${Math.round(n)}`}:null;}
  const m=text.match(/(\d+(?:\.\d+)?)\s*(?:cm|m)?\s*[x×✕*х]\s*(\d+(?:\.\d+)?)\s*(cm|m)?/i);
  if(!m)return null;
  let a=Number(m[1]),b=Number(m[2]);if(m[3]?.toLowerCase()==='m'||(a<10&&b<10)){a*=100;b*=100;}
  if(Math.min(a,b)<20||Math.max(a,b)>1200)return null;
  return {width:Math.min(a,b),length:Math.max(a,b),label:`${Math.round(Math.min(a,b))} × ${Math.round(Math.max(a,b))}`};
 };
 const spaced=(items,max=6)=>{
  if(items.length<3)return [...items];
  const ordered=[...items].sort((a,b)=>a.width*a.length-b.width*b.length),picks=[ordered[0]];
  for(const size of ordered.slice(1,-1)){const last=picks[picks.length-1],ratio=size.width*size.length/(last.width*last.length);if(ratio>=(size.width<80?1.8:1.42))picks.push(size);}
  const largest=ordered[ordered.length-1];if(picks[picks.length-1]!==largest)picks.push(largest);
  for(const size of ordered){if((size.width===80&&size.length===120||size.width===160&&size.length===230)&&!picks.includes(size))picks.push(size);}
  picks.sort((a,b)=>a.width*a.length-b.width*b.length);
  while(picks.length>max){let closest=1,score=Infinity;for(let i=1;i<picks.length-1;i++){if(picks[i].width===80&&picks[i].length===120||picks[i].width===160&&picks[i].length===230)continue;const r=picks[i+1].width*picks[i+1].length/(picks[i-1].width*picks[i-1].length);if(r<score){score=r;closest=i;}}picks.splice(closest,1);}
  return picks;
 };
 const useful=items=>{const list=items.filter(s=>s.round?s.width>=80:s.width>=80&&s.length>=120);return list.length?list:items.slice(-1);};
 window.NolvyaSizes={parse,spaced,useful};
})();
